
import React from "react";
import "./LearningPhilosophy.css";

const LearningPhilosophy = () => {
  return (
    <section className="learning-philosophy">
      <div className="learning-philosophy-container">

        <div className="learning-quote-card">

          <div className="learning-quote-content">
            <div className="quote-mark">“</div>

            <h2>
              The children learn through different
              methodologies adopted by the school.
            </h2>

            {/* <div className="quote-author">
              <span className="quote-label">Airforce</span>
            </div> */}
          </div>

          <a
            href="https://your-parent-portal-link.com"
            target="_blank"
            rel="noopener noreferrer"
            className="parent-portal-btn"
          >
            <i className="bi bi-box-arrow-up-right"></i>
            Parent Portal
          </a>

        </div>

      </div>
    </section>
  );
};

export default LearningPhilosophy;
